import cn from 'classnames'
import { memo, type ReactElement } from 'react'
import { PRETTY_TRANSACTION_TYPE, TransactionType } from '../../types/GlobalTranactionTypeEnum'

interface TypeLabelProps {
  type: TransactionType
}

const TYPES_TEXT_COLORS = {
  [TransactionType.Return]: '#dc4a4a',
  [TransactionType.Sale]: '#29975B',
  [TransactionType.Recurring]: '#80729b',
  [TransactionType.ConversionOnly]: '#29975B'

}

const TYPE_BG_COLORS = {
  [TransactionType.Return]: '#FACCD3',
  [TransactionType.Sale]: '#E1F4EC',
  [TransactionType.Recurring]: '#ffffff',
  [TransactionType.ConversionOnly]: '#E1F4EC'
}

function TransactionTypeLabel ({ type }: TypeLabelProps): ReactElement {
  return (
    <div
      className={
        cn(
          'rounded-full font-semibold text-center py-1 px-2',
          type === TransactionType.Return && 'italic'
        )
      }
      style={{
        backgroundColor: TYPE_BG_COLORS[type],
        border: '1px solid',
        borderColor: TYPES_TEXT_COLORS[type],
        color: TYPES_TEXT_COLORS[type]
      }}
    >
      {PRETTY_TRANSACTION_TYPE[type]}
    </div>
  )
}

export default memo(TransactionTypeLabel)
